import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import { FirebaseContext } from "../../FirebaseInit";
import myStyles from "./Style";
import MessageHost from "../ChatMessageHost/MessageHost";
import ChatHeader from "../ChatHeader/ChatHeader";
import ChatInput from "../ChatInput/ChatInput";
import { CircularProgress, Typography } from "@material-ui/core";
import { ChatRounded } from "@material-ui/icons";

const monthNames = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

class Chat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      privateMessages: {},
      groupMessages: {},
      chatData: null,
      loading: true,
    };
  }

  componentDidMount() {
    this.setState({ initStatus: "pendingUpdate" });
  }

  componentDidUpdate(prevProps) {
    const firebase = this.context;
    const { chaType, chat } = this.props;
    if (chat === null) {
      this.chatListener && this.chatListener();
      this.groupListener && this.groupListener();
      if (prevProps.chatDeleted === false && this.props.chatDeleted === true) {
        let emailOrName =
          prevProps.chaType === "private"
            ? prevProps.chat.email
            : prevProps.chat.name;
        if (prevProps.chaType === "private") {
          let messages = this.state.privateMessages;
          delete messages[emailOrName];
          this.setState({ privateMessages: messages, chatData: null });
        } else if (prevProps.chaType === "group") {
          let messages = this.state.groupMessages;
          delete messages[emailOrName];
          this.setState({ groupMessages: messages, chatData: null });
        }
      }

      return;
    }
    let chatUpdating = {
      id: null,
      updating: false,
    };
    if (
      (prevProps.chat && prevProps.chat.id !== this.props.chat.id) ||
      this.state.initStatus === "pendingUpdate" ||
      prevProps.chat === null
    ) {
      if (this.state.initStatus === "pendingUpdate")
        this.setState({ initStatus: "Updated", loading: true });
      else this.setState({ loading: true });

      //? Start Chat Listener
      if (chaType === "private") {
        this.groupListener && this.groupListener();
        this.chatListener && this.chatListener();
        this.chatListener = firebase
          .fs()
          .collection("chats")
          .doc(chat.id)
          .onSnapshot((snap) => {
            if (chatUpdating.id === snap.id && chatUpdating.updating) return;
            chatUpdating = {
              id: snap.id,
              updating: true,
            };

            let privateMessages = {};

            let index = snap.data().activeMembers.findIndex((item) => {
              return item === chat.email;
            });

            let recStatus =
              index === 0 ? snap.data().status1 : snap.data().status2;

            let recKey = Object.keys(snap.data().membersInfo).filter((key) => {
              return key !== this.props.user.uid;
            });
            let joinedTS = snap.data().membersInfo[this.props.user.uid].joined;

            let chatData = {
              id: snap.id,
              ...snap.data().membersInfo[recKey],
              activeMembers: snap.data().activeMembers,
              unread: snap.data().unread,
              count: snap.data().count,
              blocked: snap.data().blocked,
              recStatus: recStatus,
            };

            let messages = this.state.privateMessages[chat.email]
              ? this.state.privateMessages[chat.email]
              : [];
            let lastmsg =
              messages.length > 0 ? messages[messages.length - 1].timestamp : 0;

            if (
              this.state.chatData &&
              this.state.chatData.id === snap.id &&
              this.state.chatData.lastmod.toDate().getTime() ===
                snap.data().lastmod.toDate().getTime()
            ) {
              this.setState({
                chatData: chatData,
                loading: false,
              });
              chatUpdating = {
                id: snap.id,
                updating: false,
              };
              return;
            }

            const ref =
              lastmsg === 0
                ? firebase
                    .fs()
                    .collection("chats")
                    .doc(snap.id)
                    .collection("messages")
                    .where("timestamp", ">", joinedTS)
                    .orderBy("timestamp")
                : firebase
                    .fs()
                    .collection("chats")
                    .doc(snap.id)
                    .collection("messages")
                    .where("timestamp", ">", lastmsg)
                    .orderBy("timestamp");

            ref
              .get()
              .then((docs) => {
               if (docs.empty) {
                  this.setState({
                    loading: false,
                    chatData: chatData,
                  });
                  chatUpdating = {
                    id: snap.id,
                    updating: false,
                  };
                  return;
                }
                let lastday = lastmsg !== 0 ? lastmsg.toDate().getDate() : 0;
                docs.forEach((doc) => {
                  let date = doc.data().timestamp.toDate();
                  let day = date.getDate();
                  if (day === 1 && lastday >= 28) lastday = 0;
                  if (day > lastday) {
                    let strDate = `${
                      monthNames[date.getMonth()]
                    } ${date.getDate()} ${date.getFullYear()}`;
                    let message = {
                      message: strDate,
                      type: "info",
                    };
                    messages.push(message);
                    lastday = day;
                  }

                  messages.push({ ...doc.data() });
                });
                privateMessages[chat.email] = messages;
                this.setState({
                  chatData: chatData,
                  privateMessages: {
                    ...this.state.privateMessages,
                    ...privateMessages,
                  },
                  loading: false,
                });
                chatUpdating = {
                  id: snap.id,
                  updating: false,
                };

                messages = [];
              })
              .catch((err) =>
                this.props.toggleAlert(
                  "Error loading private messages.  Please check your internet connection.",
                  "error"
                )
              );
          });
      }
      //? End Chat Listener
      //? Start Group Listener
      else if (chaType === "group") {
        this.chatListener && this.chatListener();
        this.groupListener && this.groupListener();
        this.groupListener = firebase
          .fs()
          .collection("groups")
          .doc(chat.id)
          .onSnapshot((snap) => {
            if (this.props.chat === null) return;
            if (chatUpdating.id === snap.id && chatUpdating.updating) return;
            chatUpdating = {
              id: snap.id,
              updating: true,
            };
            let groupMessages = {};
            let grpName = snap.data().name;
            let messages = this.state.groupMessages[grpName]
              ? this.state.groupMessages[grpName]
              : [];
            let lastmsg =
              messages.length > 0 ? messages[messages.length - 1].timestamp : 0;
            if (!snap.data().membersInfo[this.props.user.uid]) return;
            let joinedTS = snap.data().membersInfo[this.props.user.uid].joined;

            if (
              this.state.chatData &&
              this.state.chatData.id === snap.id &&
              this.state.chatData.lastmod.toDate().getTime() ===
                snap.data().lastmod.toDate().getTime()
            ) {
              this.setState({
                chatData: { id: snap.id, ...snap.data() },
                loading: false,
              });
              chatUpdating = {
                id: snap.id,
                updating: false,
              };
              return;
            }

            const ref =
              lastmsg === 0
                ? firebase
                    .fs()
                    .collection("groups")
                    .doc(snap.id)
                    .collection("messages")
                    .where("timestamp", ">", joinedTS)
                    .orderBy("timestamp")
                : firebase
                    .fs()
                    .collection("groups")
                    .doc(snap.id)
                    .collection("messages")
                    .where("timestamp", ">", lastmsg)
                    .orderBy("timestamp");

            ref
              .get()
              .then((docs) => {
                if (docs.empty) {
                  this.setState({
                    loading: false,
                    chatData: { id: snap.id, ...snap.data() },
                  });
                  chatUpdating = {
                    id: snap.id,
                    updating: false,
                  };
                  return;
                }
                let lastday = lastmsg !== 0 ? lastmsg.toDate().getDate() : 0;
                docs.forEach((doc) => {
                  if (doc.data().type && doc.data().type === "info") {
                    messages.push(doc.data());
                    return;
                  }
                  let date = doc.data().timestamp.toDate();
                  let day = date.getDate();

                  if (day === 1 && lastday >= 28) lastday = 0;
                  if (day > lastday) {
                    let strDate = `${
                      monthNames[date.getMonth()]
                    } ${date.getDate()} ${date.getFullYear()}`;
                    let message = {
                      message: strDate,
                      type: "info",
                    };
                    messages.push(message);
                  }
                  messages.push(doc.data());
                  lastday = doc.data().timestamp.toDate().getDate();
                });
                groupMessages[grpName] = messages;

                this.setState({
                  chatData: { id: snap.id, ...snap.data() },
                  groupMessages: {
                    ...this.state.groupMessages,
                    ...groupMessages,
                  },
                  loading: false,
                });
                chatUpdating = {
                  id: snap.id,
                  updating: false,
                };
              })
              .catch((err) => {
                this.props.toggleAlert(
                  "Error getting group messages. Please check your internet connection.",
                  "error"
                );
              });
          });
      }
      //? End Group Listener
    }
  }

  componentWillUnmount() {
    this.chatListener && this.chatListener();
    this.groupListener && this.groupListener();
  }

  render() {
    const {
      classes,
      chat,
      chaType,
      user,
      toggleAlert,
      toggleDialog,
    } = this.props;

    const { privateMessages, groupMessages, loading, chatData } = this.state;

    if (!this.props.chat)
      return (
        <Box
          display="flex"
          position="relative"
          flexDirection="column"
          className={classes.content}
          alignItems="center"
          justifyContent="center"
        >
          <ChatRounded
            style={{
              fontSize: "100px",
              marginBottom: "30px",
              opacity:0.7
            }}
          />
          <Typography variant="h5" component="h4" color="textSecondary">
            Select a contact to start chatting!
          </Typography>
        </Box>
      );

    const messages =
      chaType === "private"
        ? privateMessages[chat.email]
        : groupMessages[chat.name];

    return (
      <Box
        display="flex"
        position="relative"
        flexDirection="column"
        className={classes.content}
      >
        {loading || (chatData && chatData.id !== chat.id) || !chatData ? (
          <Box className={classes.msgLoad}>
            <CircularProgress size={50} />
          </Box>
        ) : (
          <>
            <ChatHeader
              toggleAlert={toggleAlert}
              toggleDialog={toggleDialog}
              chatData={chatData}
              chaType={chaType}
            />

            <MessageHost
              chatData={chatData}
              messages={messages}
              user={user}
              chaType={chaType}
            />

            <ChatInput user={user} chaType={chaType} chatData={chatData} />
          </>
        )}
      </Box>
    );
  }
}
Chat.contextType = FirebaseContext;
export default withStyles(myStyles)(Chat);
